import React from 'react';
import { Loader2 } from 'lucide-react';
import clsx from 'clsx';

interface LoadingSpinnerProps {
  /**
   * Size rule:
   * - 'sm' — inline within a section (w-5 h-5)
   * - 'md' — view-level content area (w-8 h-8)  ← default
   * - 'lg' — full-page / app-level gate (w-10 h-10)
   */
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizes = {
  sm: 'w-5 h-5',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
};

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', className }) => (
  <Loader2 className={clsx('animate-spin text-brand', sizes[size], className)} />
);
